import React, { Fragment, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { getAllUsers, markSeenAllMessages } from "../../Services/UserService";
import Spinner from 'react-bootstrap/Spinner';
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { useNavigate } from "react-router";
import { BiSolidUserDetail } from "react-icons/bi";
import { Modal, Button, ListGroup } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const UserTable = () => {
    const [openUserDetailModal, setOpenUserDetailModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [userList, setUserList] = useState([]);
    const [filteredUserList, setFilteredUserList] = useState([]);
    const [pending, setPending] = useState(true);
    const [selectedDate, setSelectedDate] = useState(null);

    const navigate = useNavigate();

    const getAllUserList = async () => {
        try {
            const res = await getAllUsers();
            setUserList(res.data);
            setFilteredUserList(res.data);
        } catch (error) {
            console.log(error);
        } finally {
            setPending(false);
        }
    };

    useEffect(() => {
        getAllUserList();
    }, []);

    const formattedDate = (createdDate) => {
        const date = new Date(createdDate);
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    };

    useEffect(() => {
        if (!selectedDate) {
            setFilteredUserList(userList);
        } else {
            const filtered = userList.filter(user => {
                const created = new Date(user.createdAt);
                return created.toDateString() === selectedDate.toDateString();
            });
            setFilteredUserList(filtered);
        }
    }, [selectedDate, userList]);

    // const handleMarkSeenMessages = async (row) => {
    //     console.log(row);return
    //     const response = await markSeenAllMessages();
    //     console.log(response);
    // }

    const Columns = [
        {
            name: "User Name",
            selector: (row) => row["full_name"],
            sortable: true,
            minWidth: "200px",
            maxWidth: "300px",
        },
        {
            name: "Joined On",
            selector: (row) => row["createdAt"],
            sortable: true,
            minWidth: "200px",
            maxWidth: "300px",
            cell: (row) => <div>{formattedDate(row?.createdAt)}</div>,
        },
        {
            name: "Contact",
            selector: (row) => row["phone"],
            sortable: true,
            minWidth: "200px",
            maxWidth: "300px",
        },
        {
            name: "Email",
            selector: (row) => row["email"],
            sortable: true,
            minWidth: "200px",
            maxWidth: "300px",
        },
        {
            name: "Chat",
            minWidth: "100px",
            maxWidth: "180px",
            cell: (row) => (
                <div
                    onClick={() => {
                        // handleMarkSeenMessages(row);
                        navigate(`/user-chat/${row?._id}`, {
                            replace: true,
                            state: { user_id: row?._id, full_name: row?.full_name },
                        });
                    }}
                    style={{ cursor: "pointer" }}
                >
                    <IoChatboxEllipsesOutline size={24} />
                </div>
            ),
        },
        {
            name: "Details",
            center: true,
            minWidth: "60px",
            maxWidth: "120px",
            cell: (row) => (
                <div
                    onClick={() => {
                        setOpenUserDetailModal(true);
                        setSelectedRow(row);
                    }}
                    style={{ cursor: "pointer" }}
                >
                    <BiSolidUserDetail size={24} />
                </div>
            ),
        },
    ];

    return (
        <Fragment>
            <div className="d-flex justify-content-end align-items-center mb-3">
                <label className="me-2"><strong>Filter by Date:</strong></label>
                <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    placeholderText="Select date"
                    className="form-control"
                    maxDate={new Date()}
                    isClearable
                />
            </div>

            <div className="table-responsive support-table">
                {pending ? (
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                ) : (
                    <DataTable
                        columns={Columns}
                        data={filteredUserList}
                        striped
                        center
                        pagination
                    />
                )}
            </div>

            {/* Modal for User Details */}
            <Modal show={openUserDetailModal} onHide={() => setOpenUserDetailModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>User Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ListGroup variant="flush">
                        <ListGroup.Item className="mb-2">
                            <strong>Name:</strong> {selectedRow?.full_name || "N/A"}
                        </ListGroup.Item>
                        <ListGroup.Item className="mb-2">
                            <strong>Email:</strong> {selectedRow?.email || "N/A"}
                        </ListGroup.Item>
                        <ListGroup.Item className="mb-2">
                            <strong>Phone:</strong> {selectedRow?.phone || "N/A"}
                        </ListGroup.Item>
                        <ListGroup.Item className="mb-2">
                            <strong>Address:</strong> {selectedRow?.location?.address || "N/A"}
                        </ListGroup.Item>
                        <ListGroup.Item className="mb-2">
                            <strong>State ID:</strong>
                            <a
                                href={selectedRow?.state_id}
                                target="_blank"
                                rel="noopener noreferrer"
                            > {selectedRow?.state_id || "N/A"}
                            </a>
                        </ListGroup.Item>
                    </ListGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setOpenUserDetailModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default UserTable;
